import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

import { Holerite } from '../_classes/holerite';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Util } from './../_classes/util';

@Component({
  selector: 'app-holerite',
  templateUrl: './holerite.component.html',
  styleUrls: ['./holerite.component.scss'],
})
export class HoleriteComponent implements OnInit {
  private readonly recurso: string = 'holerite';
  arquivoUrl: any;
  hidePdfViewer = true;

  carregando = false;
  //  servidor$: Observable<Servidor>;
  //  servidor: Servidor = null;
  holeriteSelecionado: Holerite = null;

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Holerite[]>;
  dataSource: MatTableDataSource<Holerite>;
  displayedColumns: string[] = [
    'anoFol',
    'dtObtencaoDado',
    'txtContaPessoavinculada',
    'obs',
    'ver',
  ];

  modalRef: BsModalRef;
  config = {
    keyboard: true,
    class: 'modal-lg',
  };

  itensAjuda = [
    {
      titulo: 'Anotação',
      texto:
        'Informações de mês/ano e sequencial de folha do holerite. Incluindo descritivo chamado "anotação"',
    },
    { titulo: 'Liberação', texto: 'Data de liberação da folha' },
    {
      titulo: 'Banco',
      texto:
        'Dados de banco, agência e conta para onde foi enviado o valor (R$)',
    },
    {
      titulo: 'Dados',
      texto:
        'Informações da referência salarial, FC e lotação. Utilizados no respectivo holerite',
    },
    {
      titulo: 'Observações',
      texto:
        'Observações adicionais como férias, licenças, substituições, anuênios e por ventura alguma anotação individual no holerite',
    },
    {
      titulo: 'Ver',
      texto: 'Coluna que dá opção para você ver o documento ou fazer download',
    },
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private sanitizer: DomSanitizer,
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private modalService: BsModalService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  buscar(pTemplate: TemplateRef<any>, h: Holerite, pBaixar: boolean) {
    //console.log('kk-buscar(h)', pBaixar);
    this.carregando = true;
    if (this.env.servidor) {
      this.service
        .getHolerite(this.env.servidor.idServidor, h)
        .subscribe((a: Holerite) => {
          if (a) {
            this.executarAoMostrarOuDownloadBlob(
              a.holerite,
              pTemplate,
              pBaixar,
              new Holerite(a).nomeArquivo()
            );
          } else {
            this.carregando = false;
            this.handleError(
              'Holerite não encontrado ou não disponível para download'
            );
          }
        });
    }
  }

  mostrar(pTemplate: TemplateRef<any>, h: Holerite) {
    //console.log('mostrar Holerite', h);
    this.holeriteSelecionado = new Holerite(h);
    this.buscar(pTemplate, h, false);
  }

  nomeDoArquivo(x: Holerite) {
    return x.nomeArquivo();
  }

  downloadDentroDaVisualizacao() {
    this.buscar(null, this.holeriteSelecionado, true);
  }

  download(h: Holerite) {
    //console.log('kk-download(h)', h);
    this.buscar(null, h, true);
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  ngOnInit() {
    this.atualizar();
  }

  //executarAoCarregarServidor(x: Servidor) {
  //    console.log('buscou servidor Observable executarAoCarregarServidor()', x);
  //this.servidor = new Servidor(x);
  //}

  executarAoCarregarDatasource(x: Holerite[]) {
    this.dataSource = new MatTableDataSource<Holerite>(x);
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  executarAoMostrarOuDownloadBlob(
    x: Blob,
    template: TemplateRef<any>,
    pBaixar: boolean,
    nomeDoArquivo: string
  ) {
    //console.log('kk-executarAoMostrarOuDownloadBlob(x)', x, nomeDoArquivo);
    const blob = new Blob([Util.Base64ToBlob(x)], {
      type: 'application/pdf',
    });
    this.arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    if (!pBaixar) {
      this.modalRef = this.modalService.show(template, this.config);
    } else {
      let newVariable: any = window.navigator;
      if (newVariable && newVariable.msSaveOrOpenBlob) {
        newVariable.msSaveOrOpenBlob(blob); //console.log('Carregando aterado2', this.carregando);
        return;
      }
      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(blob);

      let link = document.createElement('a');
      link.href = data;
      link.download = nomeDoArquivo;
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );

      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        this.carregando = false;
      }, 100);
    }
    this.carregando = false;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  /*
  atualizarOld() {
    this.carregando = true;
    console.log('this.servidor', this.servidor);
    this.servidor = this.servService.getServidorAtualRedirecionando('holerite');
    this.servidor$ = this.servService.getServidor();

    if (!this.servidor) {
      this.rest
        .getServidor(this.keycloak.kc.getUsername().toLocaleUpperCase())
        .subscribe(
          (x: Servidor) => {
            console.log('SERVIDOR BUSCADO', x);
            let servidorSrh2$: Observable<ServidorSrh2>;

            servidorSrh2$ = this.rest.getServidorSrh2(x.nrMatricula); //.pipe(take(1));

            servidorSrh2$.subscribe(
              (a) => {
                if (x) {
                  x.servidorSrh2 = new ServidorSrh2(a);
                  this.servService.alterarServidor(x);
                  this.servidor = new Servidor(x);
                  this.buscarHolerites();
                }
              },
              (e) => {
                return EMPTY;
              }
            );
          },
          (e) => {
            this.handleError(
              e +
                'Erro ao tentar conectar (' +
                this.keycloak.kc.getUsername().toLocaleUpperCase() +
                ') (keycloak) '
            );
          }
        );
    } else {
      this.buscarHolerites();
    }
  }

*/

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    if (this.env.servidor?.idServidor) {
      //console.log('buscando holerites');
      this.dataSource$ = this.service
        .listarHolerite(this.env.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return EMPTY;
          })
        );
    } else {
      //console.log('NÃO buscando holerites', this.env.servidor);
      this.carregando = false;
    }
  }
  /*
Fiz essa bosta funcionar. Pelo que parece funciona assim:
Ao buscar inicial
- ele chama o inicial
- posso navegar para qualquer lugar que já tem as variáveis (parece não chamar início novamente);

Ao buscar qualquer rota
- busca primeiro o inicial
- o que me obriga a buscar a pessoa pelo KC sempre;
*/
  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo('Erro!! ', e);
  }

  imagemBanco(banco: number) {
    let resultado = 'bank_building_128px.png';

    if (banco) {
      if (
        [1, 33, 77, 104, 237, 260, 290, 341, 399, 746, 748, 756].find(
          (nr) => nr === banco
        )
      ) {
        resultado = banco + '.png';
      }
    }
    return './assets/imagens/bancos/' + resultado;
  }
}
